import { cn } from '@/lib/utils';
import { StatusBadge } from './StatusBadge';
import { ChannelBadge } from './ChannelBadge';
import type { DashboardItem } from '@shared/types';

interface Props {
  item: DashboardItem;
  selected: boolean;
  onSelect: () => void;
}

export function ItemRow({ item, selected, onSelect }: Props) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-current={selected ? 'true' : undefined}
      className={cn(
        'w-full text-left px-3 py-2 rounded-md hover:bg-muted transition-colors',
        selected && 'bg-muted',
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <StatusBadge status={item.status} />
          <ChannelBadge baseBranch={item.baseBranch} />
        </div>
        <span className="text-xs text-muted-foreground shrink-0">#{item.number}</span>
      </div>
      <div className="mt-1 text-sm font-medium line-clamp-2">{item.title}</div>
    </button>
  );
}
